import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../utils';
import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { hasErrors } from '../formErrors/utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

// Olje errors consists of three categories - the main category Olje, with two subgroups: "Oljekamin",
// and "Oljekjel med vannbåren varme".
export const OljeErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.olje' });

  const errors = formState.errors.olje;

  const oljeError = errors?.value?.kamin?.selected;
  const oljekaminErrors = errors?.value?.kamin?.value;
  const oljekjelErrors = errors?.value?.kjel?.value;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      {oljeError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={oljeError} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(oljekaminErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('kamin.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={oljekaminErrors?.installasjonsAr} />
            <ErrorLinkItem error={oljekaminErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={oljekaminErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(oljekjelErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('kjel.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={oljekjelErrors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={oljekjelErrors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={oljekjelErrors?.varmesentral?.varmesentralType} />
            <ErrorLinkItem error={oljekjelErrors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={oljekjelErrors?.installasjonsAr} />
            <ErrorLinkItem error={oljekjelErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={oljekjelErrors?.serviceGjennomfortSiste2Ar} />
            <ErrorLinkItem error={oljekjelErrors?.bruk?.romoppvarming} />
            <ErrorLinkItem error={oljekjelErrors?.radiator?.selected} />
            <ErrorLinkItem error={oljekjelErrors?.radiator?.value?.termostatstyring} />
            <ErrorLinkItem error={oljekjelErrors?.gulvvarme?.value?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
